import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { IUpdateUserEmailPayload } from "../models/user/update-user-email-payload";
import { IUpdateUserLoginPayload } from "../models/user/update-user-login-payload";
import { IUpdateUserPasswordPayload } from "../models/user/update-user-password-payload";

@Injectable({ providedIn: "root" })
export class UserService {
  constructor(private readonly _httpClient: HttpClient) {}

  updatePassword(payload: IUpdateUserPasswordPayload) {
    return this._httpClient.put<void>(this.withBaseUrl("/password"), payload);
  }

  updateLogin(payload: IUpdateUserLoginPayload) {
    return this._httpClient.put<void>(this.withBaseUrl("/login"), payload);
  }

  updateEmail(payload: IUpdateUserEmailPayload) {
    return this._httpClient.put<void>(this.withBaseUrl("/email"), payload);
  }

  private withBaseUrl(endpoint = "") {
    return `${environment.serverUrl}/user${endpoint}`;
  }
}
